/* eslint-disable comma-dangle */

export default {
    address: [
    'user-input',
        'map',
        'highway',
        'underground'
    ],
    'about-object': [
        'common/cadastral-number',
        'specialty-required',
        'property-type',
        'commercial-total-area',
        'floor-commercial',
        'ceiling-height',
        'condition-type',
        'has-furniture',
        'has-equipment'
    ],
    'price-and-deal-terms': [
        'price-with-vat',
        'vat-type',
        'monthly-income',
        'estate-type',
        'agent-bonus'
    ]
};
